import { CellContext } from "@tanstack/react-table"

import { ApiTypes, UITypes } from "types"

import { getProductTypeLabel } from "utils/getProductTypeLabel"
import { getSensorProductType } from "utils/getSensorProductType"

import { QuantityChipItem, QuantityChips } from "./QuantityChips"

interface SensorsQuantityProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

const SensorsQuantity = ({ cell }: SensorsQuantityProps) => {
  const { id, item } = cell.row.original.rowSettings
  const sensors = item?.sensors as ApiTypes.Model.SensorTabSensor[] | undefined

  if (!sensors?.length) return null

  const countsByType = sensors.reduce<Record<number, number>>((acc, sensor) => {
    acc[sensor.type] = (acc[sensor.type] || 0) + 1
    return acc
  }, {})

  const chipItems = Object.entries(countsByType).reduce<QuantityChipItem[]>((acc, [typeCode, quantity]) => {
    const productType = getSensorProductType(Number(typeCode))
    if (productType) acc.push({ productType, quantity, label: getProductTypeLabel(productType) })
    return acc
  }, [])

  if (!chipItems.length) return null

  return <QuantityChips items={chipItems} idSeed={id} />
}

export default SensorsQuantity
